import {
  assetsModule,
  categoriesModule,
  menuModule,
  settingsModule,
  usersModule,
} from "@/store";

type LocaleDataKey = "menu" | "categories" | "assets" | "settings" | "pinnedAssets";

const loaders: Record<LocaleDataKey, (lang?: string) => Promise<void>> = {
  menu: (lang) => menuModule.Load(lang!),
  categories: (lang) => categoriesModule.Load(lang!),
  assets: (lang) => assetsModule.LoadAssetResourcesByLang(lang!),
  settings: () => settingsModule.Load(),
  pinnedAssets: async (lang) => {
    if (!usersModule.IsAuthenticated) return;
    await assetsModule.LoadPinnedAssets(lang!);
  },
};

export async function loadLocaleData(
  lang: string,
  modules: LocaleDataKey[] = ["menu", "categories", "assets", "settings", "pinnedAssets"],
): Promise<void> {
  const tasks = modules.map((key) => loaders[key](lang));
  try {
    await Promise.all(tasks);
  } catch (err) {
    console.error("loadLocaleData error:", err);
  }
}
